import { render, staticRenderFns } from "./PaperCreate.vue?vue&type=template&id=54041111&scoped=true&"
import script from "./PaperCreate.vue?vue&type=script&lang=js&"
export * from "./PaperCreate.vue?vue&type=script&lang=js&"
import style0 from "./PaperCreate.vue?vue&type=style&index=0&id=54041111&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54041111",
  null
  
)

export default component.exports